import React from 'react';

export const UserProfileContext = React.createContext({
  openUserProfile: () => {},
});
